import { unitlessNumbers } from "../../modules/unitlessNumbers/index";
import normalizeColor from "./normalizeColor";
const colorProps = {
  backgroundColor: true,
  borderColor: true,
  borderTopColor: true,
  borderRightColor: true,
  borderBottomColor: true,
  borderLeftColor: true,
  color: true,
  shadowColor: true,
  textDecorationColor: true,
  textShadowColor: true
};
function normalizeValueWithProperty(value, property) {
  let returnValue = value;
  if ((property == null || !unitlessNumbers[property]) && typeof value === "number") {
    returnValue = `${value}px`;
  } else if (property != null && colorProps[property]) {
    returnValue = normalizeColor(value);
  }
  return returnValue;
}
export {
  normalizeValueWithProperty as default
};
//# sourceMappingURL=normalizeValueWithProperty.js.map
